/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HolidaysData } from './HolidaysData';
import {
    HolidaysDataFromJSON,
    HolidaysDataFromJSONTyped,
    HolidaysDataToJSON,
} from './HolidaysData';

/**
 * 
 * @export
 * @interface StateHolidaysData
 */
export interface StateHolidaysData {
    /**
     * 
     * @type {number}
     * @memberof StateHolidaysData
     */
    year?: number;
    /**
     * 
     * @type {Array<HolidaysData>}
     * @memberof StateHolidaysData
     */
    stateHolidays?: Array<HolidaysData>;
}

/**
 * Check if a given object implements the StateHolidaysData interface.
 */
export function instanceOfStateHolidaysData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StateHolidaysDataFromJSON(json: any): StateHolidaysData {
    return StateHolidaysDataFromJSONTyped(json, false);
}

export function StateHolidaysDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateHolidaysData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': !exists(json, 'year') ? undefined : json['year'],
        'stateHolidays': !exists(json, 'stateHolidays') ? undefined : ((json['stateHolidays'] as Array<any>).map(HolidaysDataFromJSON)),
    };
}

export function StateHolidaysDataToJSON(value?: StateHolidaysData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'stateHolidays': value.stateHolidays === undefined ? undefined : ((value.stateHolidays as Array<any>).map(HolidaysDataToJSON)),
    };
}

